import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServerErrorService {
  private _serverError$ = new BehaviorSubject<boolean>(false);
  private _appError$ = new BehaviorSubject<boolean | string>(false);

  public get appError$(): Observable<boolean | string> {
    return this._appError$.asObservable();
  }

  public setAppError(value: boolean | string): void {
    this._appError$.next(value);
  }

  public get serverError$(): Observable<boolean> {
    return this._serverError$.asObservable();
  }

  public setServerError(value: boolean): void {
    this._serverError$.next(value);
  }
}
